import type {ReactElement} from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {assertNever} from '@Utils/assert-never.util';
import type {EntityCardSkeletonProps} from './entity-card-skeleton.types';
import {EntityCardSkeletonMode} from './entity-card-skeleton.types';
import styles from './entity-card-skeleton.module.scss';

/**
 * Transient placeholder echoing the entity-card shape (a cover thumbnail plus title + meta
 * lines). Every brick shares one theme so the image and text skeletons read as a single
 * surface: grey while loading, colorful (AI gradient) while the agent is generating.
 */
export function EntityCardSkeleton({mode}: EntityCardSkeletonProps): ReactElement {
  const theme = resolveBrickTheme(mode);

  return (
    <div className={styles.root}>
      <SkeletonBrick className={styles.media} theme={theme} />
      <div className={styles.text}>
        <SkeletonBrick className={styles.titleLine} height={16} radius={'4px'} theme={theme} />
        <SkeletonBrick className={styles.metaLine} height={14} radius={'4px'} theme={theme} />
      </div>
    </div>
  );
}

function resolveBrickTheme(mode: EntityCardSkeletonMode): SkeletonBrickTheme {
  switch (mode) {
    case EntityCardSkeletonMode.GENERATING:
      return SkeletonBrickTheme.AI_ROTATING_GRADIENT;
    case EntityCardSkeletonMode.LOADING:
      return SkeletonBrickTheme.LIGHT;
    default:
      return assertNever(mode);
  }
}
